import request, { requestFile } from 'utils/request'
import { getAuthStoreData } from 'utils/authStore'

export function loadSystems(data) {
  return request('admin/devices', {
    method: 'POST',
    data
  }).then(([body]) => body)
}

export function loadLastVersions() {
  return request('admin/lastversions', {
    method: 'GET'
  }).then(([body]) => body)
}

export function loadDevicesCount() {
  return request('admin/devices/count', {
    method: 'GET'
  }).then(([body]) => body)
}

export function loadSystem(deviceId) {
  return request(`admin/devices/${deviceId}`, {
    method: 'GET'
  }).then(([body]) => body)
}

const normalizeDeviceProject = project => {
  const meta = project?.Meta || {}
  const deviceIds = meta.DeviceIds || {}
  const projectCustomers = meta.ProjectCustomers || {}
  const devices = Object.keys(deviceIds)
  const users = Object.values(projectCustomers)
  const deviceCount = devices.length
  const userCount = users.length

  return {
    ...project,
    creationDate: meta.creationDate || '',
    creation_date: meta.creationDate || '',
    deviceCount,
    devices,
    name: meta.name || '-',
    n_devices: deviceCount,
    n_users: userCount,
    ownerId: project?.OwnerId || '',
    owner_id: project?.OwnerId || '',
    projectId: project?.ProjectId || '',
    project_id: project?.ProjectId || '',
    userCount,
    users
  }
}

export function loadDeviceProjects(deviceId) {
  return request(`admin/devices/projects/${encodeURIComponent(deviceId)}`, {
    method: 'GET'
  }).then(([body]) => ({
    ...(body ?? {}),
    data: Array.isArray(body?.data) ? body.data.map(normalizeDeviceProject) : []
  }))
}

export function downloadDeviceEvents(deviceId, data) {
  const authStoreData = getAuthStoreData()

  return requestFile(`admin/devices/events/${encodeURIComponent(deviceId)}`, {
    method: 'POST',
    data,
    headers: {
      // Must match the API Gateway BinaryMediaTypes so it base64-decodes the xlsx to binary.
      // With a non-matching Accept (e.g. text/csv) API Gateway returns the raw base64 string
      // and the saved .xlsx is unreadable.
      accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'content-type': 'application/json',
      ...(authStoreData ? { Authorization: authStoreData } : {})
    }
  })
}

export function updateDeviceProjects(deviceId, data) {
  return request(`admin/devices/update-projects/${encodeURIComponent(deviceId)}`, {
    method: 'PUT',
    data
  }).then(([body]) => body ?? {})
}

export function updateResetSystem(data, deviceId) {
  return request(`admin/reset/${deviceId}`, {
    method: 'PUT',
    data: data
  }).then(([body]) => body)
}

export function changeDeviceName(data, deviceId) {
  return request(`admin/devices/change-name/${deviceId}`, {
    method: 'PUT',
    data: data
  }).then(([body]) => body)
}

export function getSystemMeasurementsByTypeNew(data) {
  return request(`systems/mtype`, {
    method: 'POST',
    data
  }).then(([body]) => body)
}

export function deleteSystem(id) {
  return request(`admin/delsystem/system/${id}`, {
    method: 'DELETE'
  })
}

export function deleteSystemData(id) {
  return request(`admin/delsystem/data/${id}`, {
    method: 'DELETE'
  })
}

export function deleteSystemFromUser(id) {
  return request(`admin/delsystem/fromuser/${id}`, {
    method: 'PUT'
  })
}

export function createApiKey(data) {
  return request('systems/createApiKeys', {
    method: 'PUT',
    data
  }).then(([body]) => body)
}

export function deleteApiKey(deviceId) {
  return request(`systems/deleteApiKey/${deviceId}`, {
    method: 'PUT'
  }).then(([body]) => body)
}

export function setApiKeyStatus(data) {
  return request('systems/setApiKeyStatus', {
    method: 'PUT',
    data
  }).then(([body]) => body)
}

export function syncAirtableInformation() {
  return request(`admin/airtable`, {
    method: 'GET'
  }).then(([body]) => body)
}

export function addDeviceToUser(customerId, data) {
  // Backend can return 409 (partial success) or 411 (license limit) — allow them
  return request(`admin/devices/add-to-user/${customerId}`, {
    method: 'POST',
    data,
    allowStatuses: [409, 411]
  }).then(([body, response]) => ({ body, status: response.status }))
}

export function chatarrizarDevices(data) {
  return request(`admin/chatarrizar`, {
    method: 'POST',
    data: data
  }).then(([body]) => body)
}

export function checkChatarrizarDevices(data) {
  return request(`admin/chatarrizar/state`, {
    method: 'POST',
    data: data
  }).then(([body]) => body)
}

export function migrateDevices(data) {
  return request(`admin/migrate`, {
    method: 'POST',
    data: data
  }).then(([body]) => body)
}

export function checkMigrateDevices(data) {
  return request(`admin/migrate/state`, {
    method: 'POST',
    data: data
  }).then(([body]) => body)
}
